import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { setExceptionHandler } from '@app/store/actions';
import { FormControl } from '@material-ui/core';
import { ModalActionsComponent, PasslyTextField } from '@app/components';
import { emailInputRegex, genericErrorString } from '@app/helpers';
import { tenantsService } from '@app/services';
import { AxiosError } from 'axios';

const validator = require('validator');

export interface IReceivedData {
    dialogOpen: Function;
    aorEmail: string | undefined;
    tenantId: string;
}

export const RescueTenantDialog = (props: IReceivedData) => {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [aorEmail, setAorEmail] = useState<string | undefined>(props.aorEmail);
    const [aorEmailInvalid, setAorEmailInvalid] = useState<boolean>(false);

    useEffect(() => {
        dispatch(setExceptionHandler(true));
    }, []);

    const handleSaveBtn = (e: any) => {
        tenantsService.rescueTenant(props.tenantId, aorEmail!, handleError, handleRescueTenantSuccess);
    };

    const handleError = (response: AxiosError<any>) => {
        const error: string = genericErrorString(response);

        setErrorMessage(error);
    };

    const onAorEmailChange = (e: any) => {
        const { name, value } = e.target;

        setAorEmail(value);

        const emailChosen = value.trim();

        if (!validator.isEmpty(emailChosen) && emailInputRegex.test(emailChosen)) {
            setAorEmailInvalid(false);
        } else {
            setAorEmailInvalid(true);
        }
    };

    const handleRescueTenantSuccess = () => {
        props.dialogOpen(false);
    };

    const handleCancel = () => {
        props.dialogOpen(false);
    };

    return (
        <>
            <form method='post' className='modal__form' tabIndex={0} onKeyPress={(e: React.KeyboardEvent<HTMLFormElement>) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    handleSaveBtn(e);
                }
            }}>
                <div className='modal__body--row'>
                    <FormControl>
                        <PasslyTextField
                            name='aorEmail'
                            label={'AOR_EMAIL_ADDR'}
                            value={aorEmail}
                            onChange={onAorEmailChange}
                            id='aorEmail-input'
                            autoFocus
                            required
                            error={aorEmailInvalid}
                            helperText={aorEmailInvalid && translation('INVALID_EMAIL')}
                        />
                    </FormControl>
                </div>
            </form>

            <div className='modal__medium'>
                <div className='modal__body--row' dangerouslySetInnerHTML={{ __html: translation('RESCUE_TENANT_DISCLAIMER') }} />
            </div>

            {errorMessage !== undefined && errorMessage !== '' && <div className='modal__error'>{errorMessage}</div>}

            <ModalActionsComponent
                primaryBtn={translation('RESCUE_TENANT')}
                secondaryBtn={translation('CANCEL')}
                onClickPrimary={handleSaveBtn}
                onClickSecondary={handleCancel}
                disabled={aorEmailInvalid}
                id='rescueTenant'
            />
        </>
    );
};
